export var viewportSlideVariants = {
    open: {
        x: 0,
    },
    closed: {
        x: "100%",
        transition: { duration: 0.2 },
    },
};
